import { useMemo } from 'react'

export interface UiLayoutState {
  preset: string
  storyPanelHeight: number
  clipsPanelVisible: boolean
  videoClipsSplit: number
  activeSidebarTab: string | null
  chatPanelSize: number
  emphasis: string | null
}

const DEFAULT_LAYOUT: UiLayoutState = {
  preset: 'default',
  storyPanelHeight: 0,
  clipsPanelVisible: true,
  videoClipsSplit: 55,
  activeSidebarTab: null,
  chatPanelSize: 30,
  emphasis: null,
}

export type UiLayoutInput = {
  preset?: string
  storyPanelHeight?: number
  clipsPanelVisible?: boolean
  videoClipsSplit?: number
  activeSidebarTab?: string
  chatPanelSize?: number
  emphasis?: string
} | null | undefined

export function useUiLayout(workflowUiLayout: UiLayoutInput): UiLayoutState {
  return useMemo(() => ({
    ...DEFAULT_LAYOUT,
    ...workflowUiLayout,
    emphasis: workflowUiLayout?.emphasis ?? null,
    activeSidebarTab: workflowUiLayout?.activeSidebarTab ?? null,
  }), [
    workflowUiLayout?.preset,
    workflowUiLayout?.storyPanelHeight,
    workflowUiLayout?.clipsPanelVisible,
    workflowUiLayout?.videoClipsSplit,
    workflowUiLayout?.activeSidebarTab,
    workflowUiLayout?.chatPanelSize,
    workflowUiLayout?.emphasis,
  ])
}
